<template>
  <modal
    :name="id"
    :adaptive="true"
  >
    <div class="modal-content">
      <img
        src="@/assets/icons/close.svg"
        alt="close"
        class="close-button"
        @click="$modal.hide(id)"
      >

      <h1 class="fn-title-1 main-title">
        Відправити документ
      </h1>

      <p class="sign-modal-subtitle">
        Вкажить e-mail на який ви бажаєте відправити цей документ.
      </p>

      <DefaultInput
        key="email"
        v-model="email"
        label="E-mail"
        class="input"
        v-validate="'required'"
        :error="errors.has('email')"
      />

      <div class="buttons">
        <button
          class="main-btn second-color large-btn next-btn button"
          @click="submit"
        >
          Відправити
        </button>

        <button
          class="second-btn second-color large-btn next-btn button"
          @click="hide"
        >
          Ні, дякую
        </button>
      </div>

    </div>
  </modal>
</template>

<script>
import DefaultInput from '@/components/Ui-new/DefaultInput.vue'

export default {
  name: 'DocumentsSignModal',
  components: {
    DefaultInput
  },
  methods: {
    hide () {
      this.$modal.hide(this.$props.id)
    },
    submit () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.$emit('submit', {
              email: this.email
            })

            this.hide()
          }
        })
    }
  },
  data () {
    return {
      email: null
    }
  },
  props: ['id']
}
</script>

<style lang="less" scoped>
.modal-content {
  padding: 40px;
}
.input {
  &:first-of-type {
    margin-top: 20px;
  }
  margin-bottom: 20px;
}
.buttons {
  display: flex;
}
.button {
  margin-right: 8px;
}
.close-button {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
}
</style>
